import React, { ReactNode } from "react";

interface SVGProps {
  children?: ReactNode;
}

const Svg = ({ children }: SVGProps) => (
  <svg
    fill="none"
    height="26"
    viewBox="0 0 26 26"
    width="26"
    xmlns="http://www.w3.org/2000/svg"
  >
    {children}
  </svg>
);

export const Rect = () => (
  <Svg>
    <rect
      fillOpacity="0.1"
      height="25"
      rx="2"
      stroke="#000000"
      width="25"
      x="0.5"
      y="0.5"
    />
  </Svg>
);

export const Triangle = () => (
  <Svg>
    <path
      d="m2,0.5l17.7024,0c1.2752,0 1.9688,1.49033 1.1476,2.46594l-0.2879,0.34198l-17.46716,18.65508c-0.92971,0.993 -2.59494,0.3351 -2.59494,-1.0252l0,-18.9378c0,-0.82843 0.67157,-1.5 1.5,-1.5z"
      fill="white"
      fillOpacity="0.1"
      stroke="#000000"
    />
  </Svg>
);
